var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_1828911",
    opacity: 0.3,
    clipPath: "url(#clip0_2017_28064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.17554 2.17969L0.673399 7.68223C0.645718 7.70999 0.62573 7.74505 0.616212 7.78272L0.00635232 10.2306C-0.0118903 10.3043 0.00976291 10.3826 0.0635391 10.4364C0.104228 10.4771 0.15967 10.4996 0.216381 10.4996C0.233751 10.4996 0.251518 10.4975 0.268809 10.4931L2.71666 9.88316C2.75481 9.87365 2.78947 9.85374 2.81715 9.82606L8.31977 4.32391L6.17554 2.17969Z",
    fill: "#8C8C76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.68248 1.42959L9.07 0.817117C8.66065 0.407768 7.94721 0.408164 7.53833 0.817117L6.78809 1.56737L8.93223 3.71151L9.68248 2.96126C9.88696 2.75687 9.99959 2.48481 9.99959 2.19547C9.99959 1.90612 9.88696 1.63407 9.68248 1.42959Z",
    fill: "#8C8C76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2017_28064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.6e2c00d6ce106d2940fd894eda0fd07d.svg";
export { ForwardRef as ReactComponent };